/**
 * Harvester Prompts
 *
 * Content harvesting prompts for extracting passages and themes.
 *
 * @module config/prompts/harvester-prompts
 */
import { HARVESTER_EXTRACT_SCHEMA } from '../prompt-output-schema.js';
// ═══════════════════════════════════════════════════════════════════════════
// HARVESTER PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const HARVESTER_PASSAGE_EXTRACTION = {
    id: 'HARVESTER_PASSAGE_EXTRACTION',
    name: 'Harvester Passage Extraction',
    description: 'Extract relevant passages from content',
    template: `Extract passages relevant to the theme "{{theme}}" from this content.

For each passage:
- Extract the complete thought (don't truncate mid-sentence)
- Assess relevance to theme (0-1)
- Identify sub-themes

Content:
{{content}}

Respond with JSON:
{
  "passages": [
    {
      "text": "The extracted passage",
      "relevance": 0.0-1.0,
      "themes": ["theme1", "theme2"]
    }
  ],
  "totalFound": number,
  "confidence": 0.0-1.0
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        minContextWindow: 8192,
        maxTokens: 4096,
    },
    outputSchema: HARVESTER_EXTRACT_SCHEMA,
    version: 1,
    usedBy: ['harvester'],
};
export const HARVESTER_THEME_IDENTIFICATION = {
    id: 'HARVESTER_THEME_IDENTIFICATION',
    name: 'Harvester Theme Identification',
    description: 'Identify themes in content',
    template: `Identify the main themes in this content.

Content:
{{content}}

For each theme:
- Name: Brief label
- Description: What it covers
- Prevalence: How prominent (0-1)

Respond with JSON:
{
  "themes": [
    {
      "name": "Theme name",
      "description": "Description",
      "prevalence": 0.0-1.0
    }
  ]
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.4,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['harvester'],
};
export const HARVESTER_PROMPTS = [
    HARVESTER_PASSAGE_EXTRACTION,
    HARVESTER_THEME_IDENTIFICATION,
];
//# sourceMappingURL=harvester-prompts.js.map